import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
} from '@angular/core';

@Component({
  selector: 'i2g-job-preview-title',
  templateUrl: 'job-preview-title.component.html',
  styleUrls: ['job-preview-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobPreviewTitleComponent {
  @Input() title: string;
  @Input() description: string;
}
